import { Params } from "../queries/tickets.queries";

export const ticketingQueryKeys = {
  all: ["ticketing"] as const,
  lists: () => [...ticketingQueryKeys.all, "lists"] as const,
  event: (eventId: string) => [...ticketingQueryKeys.all, "event", eventId] as const,
  scanCount: (eventId: string) => [...ticketingQueryKeys.event(eventId), "scanCount"] as const,
  list: (params: Params) => [...ticketTypesQueryKeys.all, "list", params] as const,
};

export const ticketTypesQueryKeys = {
  all: ["tickets-types"] as const,
  event: (eventId: string) => [...ticketTypesQueryKeys.all, "event", eventId] as const,
  get: (eventId: string, structureId: string) =>
    [...ticketTypesQueryKeys.all, "get", eventId, structureId] as const,
  ticket: (eventId: string, structureId: string) =>
    [...ticketTypesQueryKeys.all, "ticket", eventId, structureId] as const,
  remainingTicketsCount: (eventId: string, structureId: string) =>
    [...ticketTypesQueryKeys.all, "remaining-tickets-count", eventId, structureId] as const,
  remainingBadgesCount: (eventId: string, structureId: string) =>
    [...ticketTypesQueryKeys.all, "remaining-badges-count", eventId, structureId] as const,
  cashRegister: () => [...ticketTypesQueryKeys.all, "cash-register"] as const,
};

export default ticketTypesQueryKeys;
